import { ShareableFile } from '../../../selectors/FileLinksSelector';

interface FileLinksSection {
  html: string;
  text: string;
}

/**
 * Creates HTML and text sections for shared file links
 * @param files Array of shareable files with URLs
 * @returns Object containing HTML and text representations of file links
 */
export const createFileLinksSection = (files: ShareableFile[]): FileLinksSection => {
  if (files.length === 0) return { html: '', text: '' };

  const htmlLinks = files.map(file =>
    `<p><a href="${file.shareUrl}" target="_blank" rel="noopener noreferrer">${file.fileName}</a></p>`
  ).join('');

  const textLinks = files.map(file =>
    `${file.fileName}: ${file.shareUrl}`
  ).join('\n');

  const html = `
    <div style="margin-top: 20px; border-top: 1px solid #eee; padding-top: 15px;">
      <p style="font-weight: bold; margin-bottom: 10px;">Shared Files:</p>
      ${htmlLinks}
    </div>
  `;

  const text = `\n\nShared Files:\n${textLinks}`;

  return { html, text };
};

